import { LoginComponent } from '../../components/LoginComponent';
import { selectProposalInfo } from '../../selectors/proposal';
import { useSelector } from 'react-redux';
import { selectIsAuthorized } from '../../selectors/user';

interface IAuthorizationContainerProps {
  onTopButtonClick(): void;
}

export const AuthorizationContainer = ({ onTopButtonClick }: IAuthorizationContainerProps) => {
  const proposalInfo = useSelector(selectProposalInfo);
  const isAuthorized = useSelector(selectIsAuthorized);

  return <LoginComponent proposalInfo={proposalInfo} isAuthorized={isAuthorized} onTopButtonClick={onTopButtonClick} />;
};
